<template>
    <div class="security-wrapper">
        <header-security v-if="isJACareerEntrepreApp"/>
        <div class="security">
            <b-container :class="[isJACareerEntrepreApp ? 'security-container' : '']">
                <b-row v-if="isIntuitApp" class="d4d-decoration">
                </b-row>
                <b-row v-if="isJAApp" class="ja-decoration">
                </b-row>
                <b-row class="d4d-login">
                    <b-col cols="12" class="mt-3">
                        <b-alert :show="true" class="error-message">
                            <div class="error-title">We encountered an issue. Please login again</div>
                        </b-alert>
                    </b-col>

                    <b-col cols="12" class="mt-4 mb-4">
                        <b-button block variant="primary" type="button" @click="logout()">Log out</b-button>
                    </b-col>
                </b-row>
                <legal-message v-if="!isJACareerEntrepreApp"/>
            </b-container>
        </div>
    </div>
</template>

<script>
    import {AuthService} from '../Services'
    import LegalMessage from "../Components/LegalMessage"
    import HeaderSecurity from "../Components/HeaderSecurity"

    export default {
        name: 'SSOError',
        components: {
            LegalMessage,
            HeaderSecurity
        },
        methods: {
            logout() {
                AuthService.redirectToLogoutURL()
            }
        }
    }

</script>
<style scoped lang="stylus">
    @import "../Styles/security_styles.styl"
</style>
